import type { Prismic } from '@landsbankinn/prismic';
import { isEmptyText, PrismicText } from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import React from 'react';
import { TextWithIcon } from '../components/slices/TextWithIcon';

interface IProps {
  title: Prismic.RichText;
  copy: Prismic.RichText;
  image: Prismic.Image;
  background: boolean;
  merge_top: boolean;
}

export const TextWithIconContainer = ({
  title,
  copy,
  image,
  background,
  merge_top,
}: IProps) => {
  const titleText = isEmptyText(title) ? null : <PrismicText value={title} />;
  const copyText = isEmptyText(copy) ? null : <PrismicText value={copy} />;

  return (
    <Segment mergeTop={merge_top}>
      <TextWithIcon
        title={titleText}
        copy={copyText}
        image={image}
        isGray={background}
        mergeTop={merge_top}
      />
    </Segment>
  );
};
